import { useGetCurrentUser } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import { REGISTRATION_ROUTES } from 'gcs-common/constants/routes';
import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
/**
 * Only renders children if the user has completed the registration flow,
 * otherwise redirects the agen/craftsman to pages where they can enter missing information.
 */
const RegisteredUserProtectedRoute = ({ children }: PropsWithChildren) => {
  const { data: currentUser } = useGetCurrentUser();
  const isRegistered = currentUser?.registered;
  const isAgent = currentUser?.isAgent;
  const isCurrentUserHasConnections = currentUser?.hasConnections;

  if (isRegistered) {
    return children;
  }

  if (isAgent || isCurrentUserHasConnections) {
    return <Navigate to={REGISTRATION_ROUTES.REGISTRATION_PROFILE} replace />;
  }

  return <Navigate to={REGISTRATION_ROUTES.REGISTRATION_EXTERNAL} replace />;
};

export default RegisteredUserProtectedRoute;
